// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.td_border {border-left: 1px solid #e1e3eb !important;}\n.p_nodata {text-align: center; font-size: 16px; font-weight: 600;}\n", ""]);
// Exports
module.exports = exports;
